'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mafmt = require('mafmt');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mafmt__default = /*#__PURE__*/_interopDefaultLegacy(mafmt);

function isValidMultiaddr(ma) {
  try {
    return mafmt__default["default"].IPFS.matches(ma);
  } catch (err) {
    return false;
  }
}

exports.isValidMultiaddr = isValidMultiaddr;
